
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import LanguageSwitcher from '../../components/feature/LanguageSwitcher';

export default function GlobalNavbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const linkClass = (path: string, highlight = false) =>
    `text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
      isActive(path) || highlight
        ? 'text-amber-400 hover:text-amber-300'
        : 'text-white hover:text-electric-blue'
    }`;

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 right-0 z-50 bg-black"
    >
      <div className="max-w-[1400px] mx-auto px-6 py-3">
        <div className="flex items-center justify-between relative">
          <div className="flex items-center gap-4">
            <Link to="/" className="cursor-pointer">
              <img
                src="https://static.readdy.ai/image/d593a46d3e3bab12cc8840a0c4cfa5e1/909708bcd66fbf3c051c3980f5af40e8.png"
                alt="Doohnuts Logo"
                className="h-[48px] w-auto object-contain"
              />
            </Link>
          </div>

          <div className="hidden lg:flex items-center gap-6 absolute left-1/2 -translate-x-1/2">
            <a href="/" className={linkClass('/')}>
              ホーム
            </a>
            <Link to="/locations" className={linkClass('/locations')}>
              ロケーション
            </Link>
            <Link to="/advertise" className={linkClass('/advertise')}>
              広告掲載
            </Link>
            <Link to="/simulator#simulator" className={linkClass('/simulator')}>
              収益シミュレーター
            </Link>
            <Link to="/partnership" className={linkClass('/partnership')}>
              パートナー
            </Link>
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <LanguageSwitcher showWhite={false} />
            <Link
              to="/advertise#inquiry-form"
              className="px-5 py-2 rounded-full border-2 border-neon-gold text-neon-gold hover:bg-neon-gold hover:text-black text-xs transition-all whitespace-nowrap cursor-pointer"
            >
              無料相談
            </Link>
          </div>

          <button
            className="lg:hidden text-white cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            className="lg:hidden mt-3 pb-3 border-t border-white/20"
          >
            <div className="flex flex-col gap-3 mt-3">
              <a
                href="/"
                className={`text-sm cursor-pointer ${
                  isActive('/') ? 'text-amber-400' : 'text-white hover:text-electric-blue'
                }`}
              >
                ホーム
              </a>
              <Link
                to="/locations"
                className={`text-sm cursor-pointer ${
                  isActive('/locations') ? 'text-amber-400' : 'text-white hover:text-electric-blue'
                }`}
              >
                ロケーション
              </Link>
              <Link
                to="/advertise"
                className={`text-sm cursor-pointer ${
                  isActive('/advertise') ? 'text-amber-400' : 'text-white hover:text-electric-blue'
                }`}
              >
                広告掲載
              </Link>
              <Link
                to="/simulator#simulator"
                className={`text-sm cursor-pointer ${
                  isActive('/simulator') ? 'text-amber-400' : 'text-white hover:text-electric-blue'
                }`}
              >
                収益シミュレーター
              </Link>
              <Link
                to="/partnership"
                className={`text-sm cursor-pointer ${
                  isActive('/partnership') ? 'text-amber-400' : 'text-white hover:text-electric-blue'
                }`}
              >
                パートナー
              </Link>
              <Link
                to="/advertise#inquiry-form"
                className="px-5 py-2 rounded-full border-2 border-neon-gold text-neon-gold hover:bg-neon-gold hover:text-black transition-all text-sm whitespace-nowrap cursor-pointer"
              >
                無料相談
              </Link>
              <div className="pt-2 border-t border-white/10">
                <LanguageSwitcher showWhite={false} />
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
}
